import { datadogRum } from '@datadog/browser-rum';
import { Button, Flex, Preloader, Text } from '@retracedgmbh/ui-components-lib';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import pkg from '../../package.json';

const RefreshToken = () => {
  const navigate = useNavigate();
  const [isLoadingLong, setIsLoadingLong] = useState(false);

  useEffect(() => {
    const timerLong = setTimeout(() => setIsLoadingLong(true), 7500);
    return () => {
      clearTimeout(timerLong);
    };
  }, []);

  if (isLoadingLong) {
    datadogRum.addError('Access Refresh Takes Long', {
      Version: pkg.version,
    });
    return (
      <section className='section'>
        <Flex
          alignItems='center'
          justify='center'
          direction='column'
          gap='xl'
          className='tw:h-[90vh]'
        >
          <Preloader loadingText='Refreshing Access' />
          <Text>
            The access takes longer than expected to refresh, you can manually
            login again if you want to.
          </Text>
          <Button variant='primary' onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Flex>
      </section>
    );
  }

  return (
    <section className='section'>
      <Flex
        alignItems='center'
        justify='center'
        direction='column'
        gap='xl'
        className='tw:h-[90vh]'
      >
        <Preloader loadingText='Refreshing Access' />
        <Text>
          We have detected a valid session in our system. You will be redirected
          to the page you wanted to access shortly.
        </Text>
      </Flex>
    </section>
  );
};

export default RefreshToken;
